import { render } from "./px-more-list.vue?vue&type=template&id=52315f18&scoped=true&ts=true"
import script from "./px-more-list.vue?vue&type=script&lang=ts"
export * from "./px-more-list.vue?vue&type=script&lang=ts"

import "./px-more-list.vue?vue&type=style&index=0&id=52315f18&lang=scss&scoped=true"
import "./px-more-list.vue?vue&type=style&index=1&id=52315f18&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52315f18"]])

export default __exports__